// parameter a refers to a relative path to a resource/href value
// parameter b refers to the current url, often window.location
// used to check for external links
export default function(a,b) {
	const urlA = new URL(a, window.location.origin);
	const urlB = new URL(b);
	return urlA.origin === urlB.origin;
}